import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["content", "icon"]

    connect() {
        // 控制器连接时的初始化
        console.log("TRX Guide controller connected")
    }

    toggle() {
        // 切换引导内容的显示/隐藏
        this.contentTarget.classList.toggle("hidden")

        // 切换图标
        if (this.contentTarget.classList.contains("hidden")) {
            this.iconTarget.innerHTML = this.getChevronDownIcon()
        } else {
            this.iconTarget.innerHTML = this.getChevronUpIcon()
        }
    }

    // 可选：添加键盘快捷键支持
    keydown(event) {
        if (event.key === "Escape") {
            this.hide()
        }
    }

    // 隐藏引导内容
    hide() {
        this.contentTarget.classList.add("hidden")
        this.iconTarget.innerHTML = this.getChevronDownIcon()
    }

    // 显示引导内容
    show() {
        this.contentTarget.classList.remove("hidden")
        this.iconTarget.innerHTML = this.getChevronUpIcon()
    }

    // 获取向下箭头图标
    getChevronDownIcon() {
        return `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-down"><path d="m6 9 6 6 6-6"/></svg>`
    }

    // 获取向上箭头图标
    getChevronUpIcon() {
        return `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-up"><path d="m18 15-6-6-6 6"/></svg>`
    }
}
